import component from './productBox.component'
import './productBox.scss'

let module = angular.module('productBox', [])
	.component('productBox', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/productBox/productBox.js